import { render, staticRenderFns } from "./task-modal.vue?vue&type=template&id=77165440&scoped=true"
import script from "./task-modal.vue?vue&type=script&lang=js"
export * from "./task-modal.vue?vue&type=script&lang=js"
import style0 from "./task-modal.vue?vue&type=style&index=0&id=77165440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77165440",
  null
  
)

export default component.exports